import type { Lang } from '@/types/lang'

const LANGS: readonly string[] = ['ru', 'en']

/** Реестр поддерживаемых языков контента — единственное место, которое решает,
 *  валиден ли `sourceLang`. Отсутствующее или незнакомое значение (бэк отдал
 *  третий язык, который UI ещё не поддерживает, напр. 'es') — 'ru'. */
export const resolveLang = (value: string | null | undefined): Lang =>
  value && LANGS.includes(value) ? (value as Lang) : 'ru'

/** Язык контента, с которого открывается редактор: язык оригинала курса. */
export const seedLangFor = (course: { id: number; sourceLang?: Lang }): Lang =>
  resolveLang(course.sourceLang)
